module.exports = __webpack_public_path__ + "static/media/learners2.4ec71afd.png";